module.exports = __webpack_public_path__ + "img/mongo-db.d46e7a40.svg";